import {Component, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { Subscription } from 'rxjs';
import { MenuFacade } from "@redux/facades/menu.facade";
import {take} from "rxjs/operators";
import {LanguageFacade} from "@redux/facades/language.facade";
declare var $: any;

@Component({
  standalone: false,
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent implements OnDestroy {
  public lang: string | null = null;
  public menuPermanent = false;
  // @ts-ignore
  public unsubscribeMenu: Subscription;

  constructor(
    private router: Router,
    public menuFacade: MenuFacade,
    public languageFacade: LanguageFacade,
    private _Activatedroute: ActivatedRoute
  ) {
    const self = this;
    self.unsubscribeMenu = self.menuFacade.menuState$.subscribe(
      ok => {
        self.menuPermanent = ok.permanent;
        $('.main-panel').removeClass(!self.menuPermanent ? 'menu-permanent' : '');
        $('.main-panel').addClass(self.menuPermanent ? 'menu-permanent' : '');
      }
    );
    const _lang = self._Activatedroute.snapshot.paramMap.get('lang');
    self.lang = _lang !== null ? _lang : 'en';
    self.languageFacade.setLanguage(self.lang);
  }

  // tslint:disable-next-line:typedef
  ngOnDestroy() {
    const self = this;
    self.unsubscribeMenu.unsubscribe();
  }

  public isMobileMenu = () => {
    return $(window).width() <= 991;
  }

  public changeStateMenu = (open: boolean) => {
    if (!this.menuPermanent) {
      this.menuFacade.setOpen(open);
    }
  }
}
